import { render, staticRenderFns } from "./DamDetail.vue?vue&type=template&id=630271ef&scoped=true&"
import script from "./DamDetail.vue?vue&type=script&lang=js&"
export * from "./DamDetail.vue?vue&type=script&lang=js&"
import style0 from "./DamDetail.vue?vue&type=style&index=0&id=630271ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630271ef",
  null
  
)

export default component.exports